import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { CampaignService } from './api/campaign.service';
import { EnrolCampaignService } from './api/enrolCampaign.service';
import { QuestionOptionService } from './api/questionOption.service';
import { QuestionsService } from './api/questions.service';
import { QuizCampaignService } from './api/quizCampaign.service';
import { QuizUsersService } from './api/quizUsers.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    CampaignService,
    EnrolCampaignService,
    QuestionOptionService,
    QuestionsService,
    QuizCampaignService,
    QuizUsersService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
